module.exports = __webpack_public_path__ + "media/Podcast_CF2_72310003.cf2630fa.mp3";